import { PRIMARY_COLOR, RED_COLOR } from '@/constants';

interface IProps {
  width?: number;
  red?: boolean;
  color?: string;
  border?: boolean;
  borderWidth?: number;
}
export function Dot(props: IProps) {
  const size = props.width || 7;
  return (
    <div
      className="dot"
      style={{
        width: size,
        height: size,
        background: props.color || (props.red ? RED_COLOR : PRIMARY_COLOR),
        borderRadius: '50%',
        marginRight: 10,
        border: props.border ? `${props.borderWidth || 3}px solid #E2E8F0` : undefined,
      }}
    />
  );
}
